export enum AddItemResult {
  Success = 'Success',
  Failure = 'Failure',
  ValidationError = 'ValidationError',
  PrimaryKeyViolation = 'PrimaryKeyViolation',
  DuplicatedValue = 'DuplicatedValue',
}
